module.exports = __webpack_public_path__ + "static/fonts/Roboto-Medium.90d1676.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/atmosphere-mask/font/Roboto-Medium.woff2
// module id = omy1
// module chunks = 0